module.exports = __webpack_public_path__ + "img/show-history.17d64705.svg";